/**
 * Map Hosts Store - Pinia
 * 
 * Manages map tile providers/hosts configuration.
 * Migrated from VueX module src/store/modules/mapHosts/
 * 
 * Note: Has cross-store dependency to settings store for persistence.
 */

import { defineStore } from 'pinia';
import { appDebugLog } from '@/utils/appDebugLog';
import GeoMoverDB from '@/db/geoMoverDB';

export const useMapHostsStore = defineStore('mapHosts', {
  state: () => ({
    mapHosts: '',
    currentMapHost: '',
    activeMapHosts: [],
    mapLayersCreated: false
  }),

  getters: {
    getAllMapHosts: (state) => state.mapHosts,
    getCurrentMapHost: (state) => state.currentMapHost,
    getActiveMapHosts: (state) => state.activeMapHosts,
    getMapLayersCreated: (state) => state.mapLayersCreated
  },

  actions: {
    /**
     * Fetch all map hosts from the database
     */
    async fetchAllMapHosts () {
      const allMapHosts = await GeoMoverDB.findAll('mapHosts', 'id', 'next');
      this.mapHosts = allMapHosts;
      return allMapHosts;
    },

    setAllMapHosts (payload) {
      this.mapHosts = payload;
    },

    setCurrentMapHost (payload) {
      this.currentMapHost = payload;
      // Cross-store call to settings
      try {
        const { useSettingsStore } = require('./settings');
        const settingsStore = useSettingsStore();
        settingsStore.updateOneSetting({ feature: 'currentMapHost', value: payload });
      }
      catch {
        appDebugLog.debug('[Pinia] Settings store not yet available for cross-store call');
      }
    },

    setActiveMapHosts (payload) {
      this.activeMapHosts = payload;
    },

    setMapLayersCreated (bool) {
      this.mapLayersCreated = bool;
    },

    toggleMapHostActive (id) {
      const host = this.mapHosts.find(h => h.id === id);
      if (host) {
        host.active = !host.active;
      }
    }
  }
});
